import { Component, ElementRef, ViewChild } from '@angular/core';
import { paramsDB, userTipeLTI } from '../../../model/lti-launch';
import { LtiService } from '../../../services/LTI/lti.service';
import { OAuthService } from '../../../services/LTI/oAuth.service';
import { WelcomeService } from '../../../services/welcome/welcome.service';
@Component({
  selector: 'app-lti-launch',
  templateUrl: './lti-launch.component.html',
  styleUrls: ['./lti-launch.component.css']
})

export class LtiLaunchComponent {

  public url: string;
  private consumerKey: string;
  private consumerSecret: string;
  private params: paramsDB[];
  private paramsForm: Object;

  @ViewChild('launchForm', { read: ElementRef, static: false }) launchForm: ElementRef;

  constructor(public readonly _LtiService: LtiService,
    private readonly _OAuthService: OAuthService,
    private _welcomeDataService: WelcomeService) {
  }

  submitForm(): void {
    setTimeout(() => this.launchForm.nativeElement.submit(), 0);
    setTimeout(() => this.launchForm.nativeElement.innerHTML = "", 0);
  }

  generateParams(): void {
    const paramsFormated = this.processParams();
    this._OAuthService.createOauthInstance(this.consumerKey, this.consumerSecret);
    this.paramsForm = this._OAuthService.generateOauthParams(this.url, paramsFormated);
  }

  processParams(): Object {
    const { ltiInformation } = this._welcomeDataService;
    return this.params.reduce((prev, curr) => {
      return {
        ...prev,
        [curr.name]: !curr.isConstant ? ltiInformation[curr.link] : curr.value
      };
    }, {});
  }

  loadInputFields(): void {
    const form = document.querySelector('#ltiForm') as any;
    for (const name in this.paramsForm) {
      const node = document.createElement('input');
      node.name = name;
      node.type = 'hidden';
      node.value = this.paramsForm[name];
      form.appendChild(node);
    }
  }

  loadClassConfiguration(userTipe: userTipeLTI): void {
    Object.assign(this,
      this._LtiService.getConfiguration(userTipe, 3));
  }

}
